<template>

  <q-chip v-if="has_deposit_amount" :label="deposit_text" :color="deposit_color"
          :text-color="deposit_text_color" dark size="md"></q-chip>

</template>

<script>
import { computed } from "vue";

export default {
  name: "PlanDeposit",
  props: {
    deposit_amount: {
      type: Number
    }
  },
  setup(props) {
    const has_deposit_amount = computed(() => props.deposit_amount >= 0);
    const deposit_text = computed(() => {
      if (has_deposit_amount.value) {
        if (props.deposit_amount === 0) {
          return 'No Deposit'
        }
        else {
          return `$${props.deposit_amount} Deposit`
        }
      }
    })
    const deposit_color = computed(() => {
      if (props.deposit_amount === 0) {
        return 'green-11';
      }
      else {
        return 'blue-1'
      }
    })

    const deposit_text_color = computed(() => {
      if (props.deposit_amount === 0) {
        return 'green-8';
      }
      else {
        return 'primary'
      }
    })

    return {
      has_deposit_amount,
      deposit_text,
      deposit_color,
      deposit_text_color
    }
  }

}
</script>

<style scoped>

</style>